var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticClass:"examHeader"},[_c('el-col',{attrs:{"span":10}},[_c('h1',[_vm._v("您正在进行模拟考试")])]),_vm._v(" "),_c('el-col',{staticClass:"totalQesNum",attrs:{"span":4,"offset":10}},[_c('span',[_vm._v("共"+_vm._s(_vm.qesList.length)+"题")])])],1),_vm._v(" "),_c('el-row',[_c('el-col')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d5c2f82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my/exam/examHeader.vue
// module id = null
// module chunks = 